/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Cell, Grid, Icon, Text, VFlow } from 'bold-ui'
import { useIsOverflowing } from 'bold-ui/lib/hooks'
import { ReactNode, useEffect, useRef, useState } from 'react'

interface AcompanhamentoExpandableFilterContainerProps<T> {
  children: ReactNode
  footer?: ReactNode
  resetDependency: T
}

export function AcompanhamentoExpandableFilterContainer<T>(
  props: Readonly<AcompanhamentoExpandableFilterContainerProps<T>>
) {
  const { children, footer, resetDependency } = props

  const [isExpanded, setIsExpanded] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  const isExpandable = useIsOverflowing(containerRef, 'vertical')
  const isToggleEnabled = isExpandable || isExpanded

  const iconAngle = isExpanded ? 'angleUp' : 'angleDown'
  const lineClamp = isExpanded ? 10 : 1
  const buttonText = isExpanded ? 'Ocultar filtros' : 'Exibir filtros'

  useEffect(() => {
    setIsExpanded(false)
  }, [resetDependency])

  const toggleExpanded = () => {
    if (isToggleEnabled) {
      setIsExpanded((current) => !current)
    }
  }

  const classes = createStyles(lineClamp)

  return (
    <VFlow vSpacing={0.5}>
      <Grid alignItems='flex-start' justifyContent='space-between' gap={0.25} gapVertical={0.25} wrap>
        <Cell size={10} style={classes.containerCell}>
          <div ref={containerRef}>{children}</div>
        </Cell>

        {isToggleEnabled && (
          <Cell size={2} style={classes.buttonCell}>
            <Button size='small' skin='ghost' onClick={toggleExpanded} style={classes.button}>
              <Text style={classes.buttonText}>{buttonText}</Text>
              <Icon icon={iconAngle} size={1} fill='info' />
            </Button>
          </Cell>
        )}

        {footer && <Cell size={12}>{footer}</Cell>}
      </Grid>
    </VFlow>
  )
}

const createStyles = (lineClamp: number) => ({
  containerCell: css`
    display: -webkit-box;
    -webkit-line-clamp: ${lineClamp};
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.6;
  `,
  buttonCell: css`
    display: flex;
  `,
  button: css`
    margin-left: auto;
  `,
  buttonText: css`
    padding-right: 0.5rem;
  `,
})
